export default "__VITE_ASSET__BPrBs7De__"